/* ZENO PDP extras: colour swatches on the Colour option, the selected value shown next to each option label
   ("Colour  Void Black", "Size  M"), the live price inside Add to Cart, the mobile gap under the header, and the desktop
   gallery arrows + photo counter, and "Select a size" (no size is pre-picked; Add to cart asks for one first).
   Swatches are solid colour squares by default. Products tagged image-swatches use each
   variant's image instead (for options that differ in more than colour, e.g. watch dials). */
(function () {
  var MAP = {
    'void black': '#0b0b0b', 'jet black': '#121212', 'black': '#121212',
    'snow white': '#f3f1ec', 'white': '#f3f1ec',
    'grey': '#8a8a8a', 'gray': '#8a8a8a',
    'blue': '#4a6585', 'blue ocean': '#1f4e8c',
    'brown': '#6b4a33', 'dark brown': '#4a3326', 'light brown': '#a07a5a',
    'red flame': '#b3261e', 'green eye': '#2f6b4f'
  };
  var IMG = null;

  function sized(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function swatches() {
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg || !/colou?r/i.test(lg.textContent)) return;
      fs.classList.add('zn-swatches');
      fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
        var lab = fs.querySelector('label[for=' + JSON.stringify(inp.id) + ']');
        if (!lab) return;
        var val = String(inp.value).trim();
        var img = IMG && IMG[val];
        var s = lab.querySelector('.zn-sw');
        if (s && (!img || s.classList.contains('zn-sw--img'))) return;
        var hex = MAP[val.toLowerCase()];
        if (!img && !hex) return;
        if (!s) {
          s = document.createElement('span');
          s.className = 'zn-sw';
          s.setAttribute('aria-hidden', 'true');
          lab.insertBefore(s, lab.firstChild);
        }
        if (img) {
          s.classList.add('zn-sw--img');
          s.style.backgroundImage = 'url(' + sized(img) + ')';
        } else {
          s.style.setProperty('--sw', hex);
        }
      });
    });
  }

  // Selected value next to each option label. Only touches the DOM when the text changes,
  // so the MutationObserver below doesn't loop.
  function labels() {
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg) return;
      var on = fs.querySelector('input[type=radio]:checked');
      var val = on ? String(on.value).trim() : '';
      if (needSize && fs === sizeFieldset()) val = '';
      var v = lg.querySelector('.zn-legend__val');
      if (!v) {
        v = document.createElement('span');
        v.className = 'zn-legend__val';
        lg.appendChild(v);
      }
      if (v.textContent !== val) v.textContent = val;
      fs.classList.add('zn-opt');
      // Size row: pull "Not sure? Find your size" up into the label line (right-aligned by CSS).
      var placed = fs.querySelector(':scope > .zn-size__placed');
      if (placed) lg.appendChild(placed);
    });
  }

  // Select a size: on products with more than one size, nothing is picked until the shopper taps a size (a link with
  // ?variant= keeps its size). Until then Add to cart reads "Select a size" and tapping it scrolls to the sizes and
  // gives them a small shake. window.ZenoSizePick tells the sticky Add to cart bar to start without a size too.
  var needSize = false;
  function sizeFieldset() {
    var f = null;
    document.querySelectorAll('.product__info-container variant-selects fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (lg && /size/i.test(lg.textContent) && fs.querySelectorAll('input[type=radio]').length > 1) f = fs;
    });
    return f;
  }
  function atcButtons() { return document.querySelectorAll('.product__info-container .product-form__submit'); }
  function applyPick() {
    var fs = sizeFieldset();
    if (fs && fs.classList.contains('zn-unpicked') !== needSize) fs.classList.toggle('zn-unpicked', needSize);
    atcButtons().forEach(function (b) {
      if (needSize && !b.querySelector('.zn-atc__pick')) {
        var s = document.createElement('span');
        s.className = 'zn-atc__pick';
        s.textContent = 'Select a size';
        b.appendChild(s);
      }
      if (b.classList.contains('zn-needs-size') !== needSize) b.classList.toggle('zn-needs-size', needSize);
    });
  }
  function picked() {
    if (!needSize) return;
    needSize = false;
    window.ZenoSizePick = { picked: true };
    applyPick();
    labels();
  }
  function nudge() {
    var fs = sizeFieldset();
    if (!fs) return;
    try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    fs.classList.remove('zn-shake');
    void fs.offsetWidth;
    fs.classList.add('zn-shake');
    setTimeout(function () { fs.classList.remove('zn-shake'); }, 600);
  }
  function initPick() {
    if (/[?&]variant=/.test(location.search) || !sizeFieldset()) return;
    needSize = true;
    window.ZenoSizePick = { picked: false };
    var st = document.createElement('style');
    st.textContent =
      '.product__info-container .product-form__submit.zn-needs-size>*:not(.zn-atc__pick){display:none!important}' +
      '.product-form__submit .zn-atc__pick{display:none}' +
      '.product-form__submit.zn-needs-size .zn-atc__pick{display:inline;position:relative;z-index:2}' +
      '.product__info-container fieldset.zn-unpicked input[type=radio]:checked+label{outline:none!important;box-shadow:none!important;background:transparent!important;color:rgb(var(--color-foreground))!important;border-color:rgba(var(--color-foreground),.25)!important}' +
      '@keyframes znShake{0%,100%{transform:none}20%{transform:translateX(-6px)}40%{transform:translateX(6px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}}' +
      '.zn-shake{animation:znShake .45s ease}';
    document.head.appendChild(st);
    applyPick();
    labels();
    document.addEventListener('click', function (e) {
      if (!needSize || !e.target.closest) return;
      if (e.target.closest('.product__info-container .product-form__submit')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
        return;
      }
      var fs = e.target.closest('fieldset.zn-unpicked');
      if (fs && e.target.closest('label, input')) picked();
    }, true);
    document.addEventListener('change', function (e) {
      if (needSize && e.target && e.target.closest && e.target.closest('fieldset') === sizeFieldset()) picked();
    }, true);
  }

  function refresh() { swatches(); labels(); applyPick(); }

  function loadImages() {
    var parts = location.pathname.split('/products/');
    if (parts.length < 2 || !window.fetch) return;
    var handle = parts[1].split('/')[0];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || (p.tags || []).indexOf('image-swatches') < 0) return;
        IMG = {};
        (p.variants || []).forEach(function (v) {
          if (!v.featured_image) return;
          (v.options || []).forEach(function (o) {
            if (!IMG[o]) IMG[o] = v.featured_image.src;
          });
        });
        swatches();
      })
      .catch(function () {});
  }

  function fmt(c) {
    c = Number(c);
    return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100));
  }

  // Mobile: put the same gap under the floating header as above it, so the first photo starts just below it.
  // Uses layout sizes (offsetTop/offsetHeight) from the announcement bar down, so it doesn't depend on when the
  // fixed header gets its final position.
  function headerGap() {
    var mw = document.querySelector('.product__media-wrapper');
    if (!mw) return;
    if (!window.matchMedia('(max-width: 749px)').matches) { mw.style.marginTop = ''; return; }
    if (window.scrollY > 5) return;
    var hw = document.querySelector('.header-wrapper'), ab = document.querySelector('.announcement-bar-section');
    var item = mw.querySelector('.product__media-item') || mw;
    if (!hw || !hw.offsetHeight) return;
    var above = hw.offsetTop;
    if (above < 0 || above > 40) above = 10;
    var base = ab ? ab.getBoundingClientRect().bottom : 0;
    var want = base + above + hw.offsetHeight + above;
    var cur = item.getBoundingClientRect().top - (parseFloat(getComputedStyle(mw).marginTop) || 0);
    mw.style.marginTop = Math.max(0, Math.round(want - cur)) + 'px';
  }

  // Desktop gallery (Represent style): one big photo at a time with arrows and a "1/12" counter, like on phones.
  // Thumbnails are hidden by CSS (assets/zeno-glass-popups.css, section 5). The arrows click the hidden thumbnail
  // buttons, so Dawn's own gallery code still does the switching. Wraps around at the ends.
  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function dgItems(viewer) {
    return Array.prototype.filter.call(viewer.querySelectorAll('.product__media-item'), function (li) { return li.getAttribute('data-media-id'); });
  }
  function dgIndex(items) {
    for (var i = 0; i < items.length; i++) if (items[i].classList.contains('is-active')) return i;
    return 0;
  }
  function dgUpdate(viewer) {
    var ui = viewer.querySelector('.zn-dg');
    if (!ui) return;
    var items = dgItems(viewer);
    var txt = (dgIndex(items) + 1) + '/' + items.length;
    var c = ui.querySelector('.zn-dg__count');
    if (c.textContent !== txt) c.textContent = txt;
    dgTint(viewer, items);
  }
  // Desktop: the photo is shown whole in a wide column, so the column takes the photo's own backdrop colour (read from
  // its top corners) and the photo appears to fill it edge to edge. CSS in zeno-pdp.css uses --zn-media-bg.
  function dgTint(viewer, items) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var li = items[dgIndex(items)], img = li && li.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src || viewer.getAttribute('data-zn-tint') === src) return;
    viewer.setAttribute('data-zn-tint', src);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      if (viewer.getAttribute('data-zn-tint') !== src) return;
      try {
        var W = 30, H = 40, c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
        var r = 0, g = 0, b = 0, n = 0;
        [[0, 0], [W - 3, 0]].forEach(function (o) {
          var d = x.getImageData(o[0], o[1], 3, 3).data;
          for (var k = 0; k < d.length; k += 4) { r += d[k]; g += d[k + 1]; b += d[k + 2]; n++; }
        });
        viewer.style.setProperty('--zn-media-bg', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
      } catch (e) {}
    };
    im.src = src;
  }
  function dgStep(mg, viewer, d) {
    var items = dgItems(viewer), n = items.length;
    if (n < 2) return;
    var next = items[(dgIndex(items) + d + n) % n];
    var id = next.getAttribute('data-media-id');
    var btn = mg.querySelector('[id^="GalleryThumbnails-"] [data-target="' + id + '"] button');
    if (btn) btn.click();
    else {
      items.forEach(function (li) { li.classList.toggle('is-active', li === next); });
      dgUpdate(viewer);
    }
  }
  function deskGallery() {
    var mg = document.querySelector('media-gallery[id^="MediaGallery-"]');
    if (!mg) return;
    var viewer = mg.querySelector('[id^="GalleryViewer-"]');
    if (!viewer || dgItems(viewer).length < 2 || !mg.querySelector('[id^="GalleryThumbnails-"]')) return;
    if (viewer.querySelector('.zn-dg')) { dgUpdate(viewer); return; }
    var ui = document.createElement('div');
    ui.className = 'zn-dg';
    ui.innerHTML = '<button type="button" class="zn-dg__btn zn-dg__btn--prev" aria-label="Previous photo">' + ARROW_L + '</button>' +
      '<button type="button" class="zn-dg__btn zn-dg__btn--next" aria-label="Next photo">' + ARROW_R + '</button>' +
      '<span class="slider-counter zn-dg__count" aria-live="polite"></span>';
    viewer.appendChild(ui);
    ui.querySelector('.zn-dg__btn--prev').addEventListener('click', function () { dgStep(mg, viewer, -1); });
    ui.querySelector('.zn-dg__btn--next').addEventListener('click', function () { dgStep(mg, viewer, 1); });
    dgUpdate(viewer);
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { dgUpdate(viewer); }, 20); })
      .observe(viewer, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  document.addEventListener('keydown', function (e) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tag = e.target && e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable)) return;
    if (document.querySelector('.zn-fit.is-open, #ZnQuickAddPanel.is-in')) return;
    var mg = document.querySelector('media-gallery[id^="MediaGallery-"]');
    var viewer = mg && mg.querySelector('[id^="GalleryViewer-"]');
    if (!viewer || !viewer.querySelector('.zn-dg')) return;
    dgStep(mg, viewer, e.key === 'ArrowLeft' ? -1 : 1);
  });

  function init() {
    initPick();
    deskGallery();
    var mw = document.querySelector('.product__media-wrapper');
    if (mw) {
      var gt;
      new MutationObserver(function () { clearTimeout(gt); gt = setTimeout(deskGallery, 40); }).observe(mw, { childList: true, subtree: true });
    }
    headerGap();
    window.addEventListener('load', headerGap);
    setTimeout(headerGap, 300);
    setTimeout(headerGap, 1200);
    window.addEventListener('resize', headerGap);
    refresh();
    loadImages();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) labels();
    });
    var box = document.querySelector('.product__info-container');
    if (box) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(refresh, 30);
      }).observe(box, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (!v) return;
        document.querySelectorAll('.zn-atc__price').forEach(function (p) {
          p.textContent = ' · ' + fmt(v.price);
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
